export type BuyerShipToContextInput =
  | {
      sap_no_shipto?: string | number | null;
      name?: string | null;
      cg_3_business_type?: string | null;
      cg_3_business_type_desc?: string | null;
      distribution_channel?: string | null;
    }
  | null
  | undefined;

export type BuyerAnalyticsContext = {
  shipto_no: string;
  shipto_name: string;
  cg3_code: string;
  cg3_name: string;
  shipto_dist_channel: string;
};

/**
 * Shared buyer ship-to dimensions for Firebase Analytics and Clarity tags.
 */
export const getBuyerAnalyticsContext = (
  selectedShipTo: BuyerShipToContextInput
): BuyerAnalyticsContext => ({
  shipto_no:
    selectedShipTo?.sap_no_shipto != null
      ? String(selectedShipTo.sap_no_shipto)
      : '-',
  shipto_name: selectedShipTo?.name ?? '-',
  cg3_code: selectedShipTo?.cg_3_business_type ?? '-',
  cg3_name: selectedShipTo?.cg_3_business_type_desc ?? '-',
  shipto_dist_channel: selectedShipTo?.distribution_channel ?? '-',
});
